import { createReducer, on } from '@ngrx/store';
import { qrCodesActions } from '../actions/qr-codes.actions';

export interface QrCodesState {
    cache: Record<string, string>;
    pending: string[];
}

const initialState: QrCodesState = {
    cache: {},
    pending: [],
};

export const qrCodesReducer = createReducer(
    initialState,
    // The cache/dedupe guard: cached or already-pending urls never enter the queue, and the effect fetches only what pending holds.
    on(qrCodesActions.loadQrCode, (state, { url }): QrCodesState => ({
        ...state,
        pending: url in state.cache || state.pending.includes(url) ? state.pending : [...state.pending, url],
    })),
    on(qrCodesActions.loadQrCodeSuccess, (state, { url, svg }): QrCodesState => ({
        ...state,
        cache: { ...state.cache, [url]: svg },
        pending: state.pending.filter((pending) => pending !== url),
    })),
    on(qrCodesActions.loadQrCodeError, (state, { url }): QrCodesState => ({
        ...state,
        pending: state.pending.filter((pending) => pending !== url),
    })),
    on(qrCodesActions.cancelLoading, (state): QrCodesState => ({
        ...state,
        pending: [],
    })),
);
